<template>
    <div class="login-setting">
        <el-form class="card-box login-form1" label-width="120px" autoComplete="on" :rules="rules" :model="formData" ref="formData">
            <h3 class="title">注册</h3>
            <el-form-item label="手机号：" prop="phone" class="redItem">
                <el-input
                    maxlength='11'
                    style="width: 300px;"
                    placeholder="请输入手机号"
                    v-model="formData.phone"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="verify_code" class="redItem">
                <el-input
                    maxlength='6'
                    style="width: 300px;"
                    class="input-ele2"
                    type="text"
                    v-model="formData.verify_code"
                    name="code"
                    placeholder="输入验证码"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
                <div class="yzm_btn" @click="obtainVerification()">{{txt}}</div>
            </el-form-item>
            <el-form-item label="密码：" prop="password" class="redItem">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入密码"
                    show-password
                    v-model="formData.password"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="企业名称：" prop="company" class="redItem">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入企业名称"
                    v-model="formData.company"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" class="redItem">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入邮箱"
                    v-model="formData.email"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-row style="margin-top:17px; ">
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import * as api from "@/api/auth/register";
import { isvalidMobile } from "@/utils/validate";
export default {
    data() {
        const validateverify_code = (rule, value, callback) => {
            if (value.length < 4) {
                callback(new Error("验证码长度不要小于4位数"));
            } else {
                callback();
            }
        };
        const validatepassword = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码长度不要小于6位数"));
            } else {
                callback();
            }
        };
        const validateQMobile = (rule, value, callback) => {
            if (!isvalidMobile(value)) {
                callback(new Error("请输入正确的电话号码"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                phone: [
                    {
                        required: true,
                        validator: validateQMobile,
                        trigger: "blur"
                    }
                ],
                verify_code: [
                    {
                        required: true,
                        validator: validateverify_code,
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        validator: validatepassword,
                        trigger: "blur"
                    }
                ],
                company: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "blur"
                    }
                ]
            },
            formData: {
                email: "",
                password: "",
                spread_uid: "",
                verify_code: ""
            },
            txt: "获取验证码",
            loading: false,
            isshow: false
        };
    },
    methods: {
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true;
                    api.phone_register(this.formData)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 关闭窗口, 刷新列表
                                this.$message({
                                    message: "注册用户成功",
                                    type: "success"
                                });
                                let obj = {};
                                obj.userName = this.formData.phone;
                                obj.pwd = this.formData.password;
                                this.$store
                                    .dispatch("loginName", obj)
                                    .then(response => {
                                        if (response.code) {
                                            return;
                                        }
                                        let path = "/";
                                        if (this.redirect) {
                                            path = this.redirect;
                                        }
                                        this.$router.push({
                                            path: path
                                        });
                                    })
                                    .catch(() => {
                                        this.loading = false;
                                    });
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        //获取验证码
        obtainVerification() {
            if (this.disabled || this.isshow) {
                return;
            }
            if (!isvalidMobile(this.formData.phone)) {
                return this.$message.error("请输入正确的手机号");
            }
            let that = this;
            const obj = {};
            obj.phone = this.formData.phone;
            this.isshow = true;
            api.send_verify_code(obj).then(res => {
                if (res.code == 0) {
                    that.timeOut();
                    this.isshow = false;
                } else {
                    this.isshow = false;
                    return that.$message.error(res.message);
                }
            });
        },
        //注册验证码的60S
        timeOut() {
            this.disabled = true;
            let num = 60;
            this.txt = num + "s";
            const nt = setInterval(() => {
                if (num <= 0) {
                    clearInterval(nt);
                    this.txt = "重新获取";
                    this.disabled = false;
                } else {
                    num--;
                    this.txt = num + "s";
                }
            }, 1000);
        }
    },
    created() {
        if (this.$route.query.spread_uid) {
            this.formData.spread_uid = this.$route.query.spread_uid;
        } else {
            this.$message({
                type: "error",
                message: "您没权限进入页面！"
            });
            let path = "/login";
            this.$router.push({
                path: path
            });
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
@import "../../styles/mixin";

$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.redItem {
    .el-form-item__label {
        color: #fff;
    }
}
.login-setting {
    // @include relative;
    height: 100%;
    background-color: black;
    background-image: radial-gradient(
            white,
            rgba(255, 255, 255, 0.2) 2px,
            transparent 40px
        ),
        radial-gradient(white, rgba(255, 255, 255, 0.15) 1px, transparent 30px),
        radial-gradient(white, rgba(255, 255, 255, 0.1) 2px, transparent 40px),
        radial-gradient(
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.1) 2px,
            transparent 30px
        );
    background-size: 550px 550px, 350px 350px, 250px 250px, 150px 150px;
    background-position: 0 0, 40px 60px, 130px 270px, 70px 100px;
    .title {
        font-size: 26px;
        color: #fff;
        margin: 0 auto 0.5333rem auto;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .login-form1 {
        @include fxied-center;
        // top: 40%;
        // width: 22em;
        padding: 0.4666rem 0.4666rem 0.2rem 0.4666rem;
    }
}
/deep/ .userProtocol {
    color: #eee !important;
}
/deep/ .userProtocol:hover {
    cursor: pointer;
    text-decoration: underline;
}
.yzm_btn {
    width: 80px;
    font-size: 12px;
    height: 40px;
    position: absolute;
    right: -2px;
    top: 0px;
    line-height: 38px;
    border-radius: 0 6px 6px 0;
    text-align: center;
    color: #fff;
    background: #107bc5;
    cursor: pointer;
    border: none;
}
</style>
